import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputHintModule } from '../../generic-input-hint/generic-input-hint.module';
import { GenericInputSlotModule } from '../../generic-input-slot/generic-input-slot.module';
import { GenericPasswordInputComponent } from './generic-password-input.component';

export * from './generic-password-input.component';

@NgModule({
    declarations: [ GenericPasswordInputComponent ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatIconModule,
        ReactiveFormsModule,
        MatInputModule,
        MatProgressBarModule,
        GenericInputHintModule,
        GenericInputSlotModule,
        TranslateModule,
        MatButtonModule,
    ],
    exports: [
        GenericPasswordInputComponent,
    ],
})
export class GenericPasswordInputModule {
}
